
import React, { useEffect, useState } from 'react';
import { ISANDROIDWEB, ISIOSWEB, PLATFORM, VERSION } from './Util';
import Splash1 from '../images/Splash1.png';
import Splash2 from '../images/Splash2.png';
import DRIcon from '../images/DRLogo2.png';
import { useNavigate } from 'react-router-dom';
import './SplashScreen.css';

 interface SSProps {
  numRunners?: number;
  numFinishers?: number;
  numMeetings?: number;
}

const SplashScreen: React.FC<SSProps> = () => {
  const [runners, setRunners] = useState('');
  const [meetings, setMeetings] = useState('');
  const [finishers, setFinishers] = useState('');

  const navigate = useNavigate();

  // Load splash data once
  useEffect(() => {
    const getSplashData = async () => {
      setRunners(localStorage.getItem('splash-runners') ?? '');
      setMeetings(localStorage.getItem('splash-meetings') ?? '');
      setFinishers(localStorage.getItem('splash-finishers') ?? '');
    };
    getSplashData().catch(console.error);
  }, []);

  useEffect(() => {
    let stopped = false;

    const waitForReady = () =>
      new Promise<void>((resolve) => {
        // already ready?
        if (localStorage.getItem('boot-ready') === '1') return resolve();
        // poll a few times per second
        const id = setInterval(() => {
          if (localStorage.getItem('boot-ready') === '1') {
            clearInterval(id);
            resolve();
          }
        }, 150);
      });

    const timeout = (ms: number) =>
      new Promise<void>((resolve) => setTimeout(resolve, ms));

    (async () => {
      try {
        await Promise.race([waitForReady(), timeout(2500)]);
      } finally {
        if (!stopped) navigate('/home', { replace: true });
      }
    })();

    return () => { stopped = true; };
  }, [navigate]);

  const stats = () => <div style={{ fontSize: 48, color: 'white', textAlign: 'center', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, height: 'fit-content', margin: 'auto' }}>
    <span>{runners} Runners</span><br />
    <span>{meetings} Events</span><br />
    <span>{finishers} Results</span><br />
    <span style={{ fontSize: 24 }}>{"Version " + VERSION}</span>
  </div>

  const splashnum = Math.floor(Math.random() * 2);
  const image = splashnum === 0 ? Splash1 : Splash2;

  let style = {};

  return (
    <>
        <div className={'splash-header-container'} style={style}>
          <img className={'icon splash-header-icon'} src={DRIcon} alt="DR" />
          <div className={'splash-header-text'}>Dulwich Runners</div>
        </div>
    <div style={{ width: '100%', position: 'relative' }}>
      {
          (PLATFORM === 'web' && !ISIOSWEB && !ISANDROIDWEB) && <img src={image} alt="" width='100%' />
      }
      {
          (PLATFORM !== 'web' || ISIOSWEB || ISANDROIDWEB) && (<><img src={Splash1} alt="" width='100%' /><img src={Splash2} alt="" width='100%' /></>)
      }
     
      {stats()}
    </div>
  </>
  )
}

export default SplashScreen;
